import PropTypes from 'prop-types'

// material-ui
import { Typography } from '@mui/material'

// project import
import NavItem from './NavItem'
import NavCollapse from './NavCollapse'
import usePermissions from 'helpers/usePermissions'

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const { hasPermission, isProfileLoaded } = usePermissions()

  const navCollapse = item.children?.map((menuItem) => {
    // Gate by uiPermission (only when profile is loaded to avoid flash-hide)
    if (menuItem.requirements?.uiPermission && isProfileLoaded && !hasPermission(menuItem.requirements.uiPermission)) {
      return null
    }

    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        )
    }
  })
  return navCollapse
}

NavGroup.propTypes = {
  item: PropTypes.object
}

export default NavGroup
